module.exports = __webpack_public_path__ + "static/img/2-3.65a8093.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-2/2-3.jpg
// module id = 730
// module chunks = 1